import { createContext } from "react";

export const LoadingContext = createContext<boolean>(true);